import { RingModelEnum } from '../enums/RingModelEnum';

export const BUSINESS_PATHNAME = '/business';
export const FITNESS_PATHNAME = '/fitness';
export const GIFT_PATHNAME = '/gift';
export const STORE_POP_PATHNAME = '/store/rings';
export const WHY_OURA_PATHNAME = '/why-oura';
export const SCIENCE_AND_RESEARCH_PATHNAME = '/science-and-research';
export const MEMBERSHIP = '/membership';
export const ACCESSORIES_ROOT_PATH = '/product/accessories';
export const STORE_ACCESSORIES_ROOT_PATH = '/store/accessories';
export const GEN3_POP_PATHNAME = `/${RingModelEnum.Gen3}`;
export const STELO_PDP_PATHNAME = '/product/dexcom/stelo-glucose-biosensor';
export const STORE_STELO_PDP_PATHNAME = '/store/dexcom/stelo-glucose-biosensor';
export const OR4_PDP_PATHNAMES = [
  '/product/rings/oura-ring-4/silver',
  '/product/rings/oura-ring-4/black',
  '/product/rings/oura-ring-4/stealth',
  '/product/rings/oura-ring-4/brushed-silver',
  '/product/rings/oura-ring-4/gold',
  '/product/rings/oura-ring-4/rose-gold',
  '/store/rings/oura-ring-4/silver',
  '/store/rings/oura-ring-4/black',
  '/store/rings/oura-ring-4/stealth',
  '/store/rings/oura-ring-4/brushed-silver',
  '/store/rings/oura-ring-4/gold',
  '/store/rings/oura-ring-4/rose-gold',
];
export const OR4_JADE_POP_PATHNAME = '/store/rings/oura-ring-4-ceramic';
export const OR4_JADE_PDP_PATHNAMES = [
  '/store/rings/oura-ring-4-ceramic/midnight',
  '/store/rings/oura-ring-4-ceramic/cloud',
  '/store/rings/oura-ring-4-ceramic/tide',
  '/store/rings/oura-ring-4-ceramic/petal',
];
